module.exports = __webpack_public_path__ + "img/square.0e40a932.svg";